var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("courseware-default-container", {
    attrs: {
      container: _vm.container,
      containerClass: "cw-container-tabs",
      canEdit: _vm.canEdit,
      isTeacher: _vm.isTeacher,
      editDataValid: _vm.editDataValid,
    },
    on: {
      showEdit: _vm.setShowEdit,
      storeContainer: _vm.storeContainer,
      closeEdit: _vm.initCurrentData,
    },
    scopedSlots: _vm._u([
      {
        key: "containerContent",
        fn: function fn() {
          return [
            _vm.showDeleteDialog
              ? _c("studipDialog", {
                  attrs: {
                    title: _vm.$gettext("Tab löschen"),
                    question: _vm.$gettext(
                      "Möchten Sie dieses Tab wirklich löschen?"
                    ),
                    height: "180",
                  },
                  on: {
                    confirm: _vm.deleteCurrentSection,
                    close: _vm.closeDeleteDialog,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.canEdit && !_vm.currentElementisLink
              ? [
                  _c(
                    "span",
                    {
                      staticClass: "assistive-text",
                      attrs: {
                        "aria-live": "assertive",
                      },
                    },
                    [_vm._v(_vm._s(_vm.assistiveLive))]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "assistive-text",
                      attrs: {
                        id: "operation",
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$gettext(
                              "Drücken Sie die Leertaste, um neu anzuordnen."
                            )
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "courseware-tabs",
              {
                on: {
                  selectTab: _vm.selectTabHandler,
                },
              },
              _vm._l(_vm.currentSections, function (section, index) {
                return _c(
                  "courseware-tab",
                  {
                    key: index,
                    attrs: {
                      index: index,
                      name: section.name,
                      icon: section.icon,
                      selected: _vm.sortInTab === index,
                    },
                  },
                  [
                    !_vm.canEdit || _vm.currentElementisLink
                      ? _c(
                          "ul",
                          {
                            staticClass: "cw-container-tabs-block-list",
                          },
                          _vm._l(section.blocks, function (block) {
                            return _c(
                              "li",
                              {
                                key: block.id,
                                staticClass: "cw-block-item",
                              },
                              [
                                _c(_vm.component(block), {
                                  tag: "component",
                                  attrs: {
                                    block: block,
                                    canEdit: _vm.canEdit,
                                    isTeacher: _vm.isTeacher,
                                  },
                                }),
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : [
                          _vm.canEdit
                            ? [
                                section.blocks.length === 0
                                  ? _c("courseware-companion-box", {
                                      attrs: {
                                        mood: "pointing",
                                        msgCompanion: _vm.$gettext(
                                          "Dieses Fach enthält keine Blöcke."
                                        ),
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "draggable",
                                  _vm._b(
                                    {
                                      staticClass:
                                        "cw-container-tabs-block-list cw-container-tabs-sort-mode",
                                      class: [
                                        section.blocks.length === 0
                                          ? "cw-container-tabs-sort-mode-empty"
                                          : "",
                                      ],
                                      attrs: {
                                        tag: "ol",
                                        role: "listbox",
                                        handle: ".cw-sortable-handle",
                                        group: "blocks",
                                        containerId: _vm.container.id,
                                        sectionId: index,
                                      },
                                      on: {
                                        start: function start($event) {
                                          _vm.isDragging = true
                                        },
                                        end: _vm.dropBlock,
                                      },
                                      model: {
                                        value: section.blocks,
                                        callback: function callback($$v) {
                                          _vm.$set(section, "blocks", $$v)
                                        },
                                        expression: "section.blocks",
                                      },
                                    },
                                    "draggable",
                                    _vm.dragOptions,
                                    false
                                  ),
                                  _vm._l(section.blocks, function (block) {
                                    return _c(
                                      "li",
                                      {
                                        key: block.id,
                                        staticClass:
                                          "cw-block-item cw-block-item-sortable",
                                      },
                                      [
                                        _c("span", {
                                          ref: "sortableHandle" + block.id,
                                          refInFor: true,
                                          staticClass: "cw-sortable-handle",
                                          class: {
                                            "cw-sortable-handle-dragging":
                                              _vm.isDragging,
                                          },
                                          attrs: {
                                            tabindex: "0",
                                            role: "button",
                                            "aria-describedby": "operation",
                                          },
                                          on: {
                                            keydown: function keydown($event) {
                                              return _vm.keyHandler(
                                                $event,
                                                block.id,
                                                index
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(_vm.component(block), {
                                          tag: "component",
                                          class: {
                                            "cw-block-item-selected":
                                              _vm.keyboardSelected === block.id,
                                          },
                                          attrs: {
                                            block: block,
                                            canEdit: _vm.canEdit,
                                            isTeacher: _vm.isTeacher,
                                            blockId: block.id,
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                ),
                              ]
                            : _vm._e(),
                        ],
                  ],
                  2
                )
              }),
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "containerEditDialog",
        fn: function fn() {
          return [
            _c(
              "form",
              {
                staticClass: "default cw-container-dialog-edit-form",
                on: {
                  submit: function submit($event) {
                    $event.preventDefault()
                  },
                },
              },
              _vm._l(
                _vm.currentContainer.attributes.payload.sections.filter(
                  function (section) {
                    return !section.locked
                  }
                ),
                function (section, index) {
                  return _c(
                    "fieldset",
                    {
                      key: index,
                      class: {
                        invalid: !section.name && !section.icon,
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$gettext("Titel")) +
                            "\n                    "
                        ),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: section.name,
                              expression: "section.name",
                            },
                          ],
                          attrs: {
                            type: "text",
                          },
                          domProps: {
                            value: section.name,
                          },
                          on: {
                            input: function input($event) {
                              if ($event.target.composing) return
                              _vm.$set(section, "name", $event.target.value)
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "label",
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$gettext("Symbol")) +
                              "\n                    "
                          ),
                          _c("studip-select", {
                            attrs: {
                              options: _vm.icons,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "open-indicator",
                                  fn: function fn(selectAttributes) {
                                    return [
                                      _c(
                                        "span",
                                        _vm._b(
                                          {},
                                          "span",
                                          selectAttributes,
                                          false
                                        ),
                                        [
                                          _c("studip-icon", {
                                            attrs: {
                                              shape: "arr_1down",
                                              size: 10,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "no-options",
                                  fn: function fn() {
                                    return [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.$gettext(
                                              "Es steht keine Auswahl zur Verfügung."
                                            )
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "selected-option",
                                  fn: function fn(option) {
                                    return [
                                      _c("studip-icon", {
                                        attrs: {
                                          shape: option.label,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "vs__option-with-icon",
                                        },
                                        [_vm._v(_vm._s(option.label))]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "option",
                                  fn: function fn(option) {
                                    return [
                                      _c("studip-icon", {
                                        attrs: {
                                          shape: option.label,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "vs__option-with-icon",
                                        },
                                        [_vm._v(_vm._s(option.label))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: section.icon,
                              callback: function callback($$v) {
                                _vm.$set(section, "icon", $$v)
                              },
                              expression: "section.icon",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.currentContainer.attributes.payload.sections.length >
                      1
                        ? _c(
                            "label",
                            {
                              staticClass: "cw-container-section-delete",
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "button trash",
                                  on: {
                                    click: function click($event) {
                                      return _vm.confirmDeleteSection(index)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$gettext("Tab löschen")))]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                }
              ),
              0
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "containerEditButtons",
        fn: function fn() {
          return [
            _c(
              "button",
              {
                staticClass: "button add",
                on: {
                  click: _vm.addSection,
                },
              },
              [_vm._v(_vm._s(_vm.$gettext("Tab hinzufügen")))]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }